import React, { useEffect, useState } from "react";
import minimalistic from "../../assets/img/minimalistic.avif";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import img1 from "../../assets/img/gallery/facility1.png";
import img2 from "../../assets/img/gallery/facility2.png";
import img3 from "../../assets/img/gallery/facility3.png";
import img4 from "../../assets/img/gallery/facility4.png";
import img5 from "../../assets/img/gallery/facility5.png";
import img6 from "../../assets/img/gallery/facility6.png";
import img7 from "../../assets/img/gallery/facility7.png";
import img8 from "../../assets/img/gallery/facility8.png";

const data = [
  {
    id: "1",
    url: img1,
  },
  {
    id: "2",
    url: img2,
  },
  {
    id: "3",
    url: img3,
  },
  {
    id: "4",
    url: img4,
  },
  {
    id: "5",
    url: img5,
  },
  {
    id: "6",
    url: img6,
  },
  {
    id: "7",
    url: img7,
  },
  {
    id: "8",
    url: img8,
  },
  {
    id: "9",
    url: img1,
  },
];

function ThirdPartyManufacturing() {
  const { t, i18n } = useTranslation();
  return (
    <>
      <Helmet>
        <title>Faility | EHL Life Sciences Pvt Ltd</title>
        <meta name="keyword" content="EHL Life Sciences Pvt Ltd" />
        <meta name="description" content="EHL Life Sciences Pvt Ltd" />
      </Helmet>
      <Breadcrumb title="Third Party Manufacturing" t={t} />
      <section className="p-30">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="facility">
                <div className="fisherman-content mt-4">
                  <h3>EHL Life Sciences Pvt Ltd</h3>
                  <p>
                    {" "}
                    At EHL Life Sciences Pvt Ltd, we are dedicated to improving
                    animal health and farm productivity through high-quality
                    veterinary feed supplements specially formulated for cattle
                    and poultry. We understand the practical challenges Indian
                    farmers face, and our products are designed to support
                    better weight gain, stronger immunity, and improved overall
                    health in livestock and poultry—whether in small rural
                    setups or large commercial farms.
                  </p>

                  <p>
                    Our supplements are manufactured in ISO-certified,
                    GMP-compliant facilities. We use quality ingredients and
                    carefully tested formulations to ensure every product is
                    safe, effective, and consistent. From feed additives to
                    vitamin-mineral mixes, we focus on results that farmers can
                    see in their animals' performance and well-being.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="row">
                {data.map((item, i) => {
                  return (
                    <div className="col-lg-4" key={i}>
                      <div className="facility">
                        <img
                          src={item.url}
                          alt="EHL Life Sciences Pvt Ltd"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="col-lg-4">
              <div className="pcdForm">
                <div className="title">
                  <h4>Get PCD & Third Party Manufacturing</h4>
                  <p>Do not post job & raw material enquiries</p>
                </div>
                <form>
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Your name"
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="mail"
                      placeholder="Your email"
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Your city"
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="number"
                      placeholder="Number"
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <textarea
                      placeholder="Your message"
                      className="form-control"
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <button className="commonButton" type="button">
                      SEND
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ThirdPartyManufacturing;
